import React from 'react'

const RightArrow = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6831 0.808058C10.9271 0.563981 11.3229 0.563981 11.5669 0.808058L15.3169 4.55806C15.561 4.80214 15.561 5.19786 15.3169 5.44194L11.5669 9.19194C11.3229 9.43602 10.9271 9.43602 10.6831 9.19194C10.439 8.94786 10.439 8.55213 10.6831 8.30806L13.9911 5L10.6831 1.69194C10.439 1.44786 10.439 1.05214 10.6831 0.808058Z"
        fill="#232452"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 5C0.5 4.65482 0.779822 4.375 1.125 4.375L14.25 4.375C14.5952 4.375 14.875 4.65482 14.875 5C14.875 5.34518 14.5952 5.625 14.25 5.625L1.125 5.625C0.779822 5.625 0.5 5.34518 0.5 5Z"
        fill="#232452"
      />
    </svg>
  )
}

export default RightArrow
